var React = require('react');

function PhpLogo (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Slice"),React.createElement("path",{"d":"M2 29l2.882-14.294h6.663c2.881.176 4.322 1.588 4.322 4.059 0 4.235-3.422 6.706-6.483 6.53H6.142L5.422 29H2zm4.862-6.353h2.162c1.62-.176 3.061-.706 3.241-3.706 0-1.059-.9-1.588-2.16-1.588H7.762l-.9 5.294zm8.336 2.647L18.079 11h3.422l-.72 3.706h3.241c2.882.176 3.962 1.588 3.602 3.353l-1.26 7.235h-3.602l1.26-6.53c.18-.882.18-1.411-1.08-1.411H20.24l-1.62 7.941h-3.422zM26.133 29l2.881-14.294h6.664c2.881.176 4.322 1.588 4.322 4.059 0 4.235-3.422 6.706-6.483 6.53h-3.242L29.555 29h-3.422zm4.862-6.353h2.161c1.621-.176 3.062-.706 3.242-3.706 0-1.059-.9-1.588-2.161-1.588h-2.341l-.901 5.294z","fillRule":"nonzero","stroke":"#222631","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

PhpLogo.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42"};

module.exports = PhpLogo;

PhpLogo.default = PhpLogo;
